import { html } from "lit";
import { ActivityHistoryIsGroupingBusy } from "./component";
import { translate } from "../../../../localization";

export const template = (_props: ActivityHistoryIsGroupingBusy) => html`
  <div class="grouping-busy-container">
    <dss-spinner size="sm"></dss-spinner>
    <div>${translate("isGrouping")}</div>
  </div>
`;
